module.exports = __webpack_public_path__ + "img/setting.2df7a4b1.svg";